var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 33,
    viewBox: "0 0 20 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.159 0C15.2709 0.207298 14.5992 0.725517 13.9649 1.35482C9.90479 5.40458 5.82983 9.43953 1.76231 13.4745C1.61304 13.6226 1.44883 13.7707 1.27717 13.8965C-0.431935 15.2144 -0.424457 17.8426 1.29211 19.1456C1.45631 19.2715 1.60557 19.4048 1.75484 19.5529C5.90445 23.6619 10.0541 27.7782 14.1963 31.8946C14.9277 32.6201 15.7784 33.0347 16.8308 32.9977C18.3831 32.9459 19.7191 31.7244 19.8982 30.1918C20.0325 29.0591 19.637 28.1336 18.8384 27.3488C15.3307 23.8765 11.8303 20.3968 8.32999 16.9172C7.86727 16.4581 7.86727 16.5766 8.32999 16.1176C11.8303 12.6379 15.3381 9.16559 18.8459 5.69331C19.4803 5.064 19.8907 4.35333 19.9877 3.45009C20.0997 2.30254 19.4354 0.984627 18.4055 0.414555C18.0697 0.229462 17.7115 0.125862 17.3532 0H16.1814H16.159Z",
    fill: "#00804E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolver);
export default __webpack_public_path__ + "static/media/volver.9df6f9c2b0f1d94a61e03e66113eae8f.svg";
export { ForwardRef as ReactComponent };